module.exports = __webpack_public_path__ + "static/media/bike1.630bc1f3.jpg";